import { configApi } from '../../../../shared/utils/http-client.js'

export const state = {
	dashboards: []
}

export const getters = {
	dashboards (state) {
		return state.dashboards
	}
}

export const mutations = {
	SET_DASHBOARDS (state, { dashboards, addCookieModule }) {
		// Override API dashboard names
		const dashboardNameOverrides = {
			1: 'Data Processing',
			3: 'Consent'
		}

		// Get dashboard IDs from the overrides constant
		const dataProcessingId = Number(Object.keys(dashboardNameOverrides).find(key =>
			dashboardNameOverrides[key] === 'Data Processing'))
		const consentId = Number(Object.keys(dashboardNameOverrides).find(key =>
			dashboardNameOverrides[key] === 'Consent'))

		// Apply name overrides to API dashboards
		const processedDashboards = dashboards
			.filter(d => [0, dataProcessingId, consentId].includes(d.id))
			.map(dashboard => ({
				...dashboard,
				name: dashboardNameOverrides[dashboard.id] || dashboard.name
			}))

		// Sort dashboards to put Consent Management before Data Processing
		const sortedDashboards = processedDashboards.sort((a, b) => {
			if (a.id === consentId && b.id === dataProcessingId) return -1 // Consent Management comes first
			if (a.id === dataProcessingId && b.id === consentId) return 1 // Data Processing comes second
			return 0 // Keep original order for other dashboards
		})

		if (addCookieModule === true) {
			const legacyDashboard = {
				id: 0,
				name: 'Consent Banners',
				isDefault: !sortedDashboards.some(d => d.isDefault) // non of the database dashboards are default set this one as default
			}
			state.dashboards = [legacyDashboard, ...sortedDashboards]
		} else {
			state.dashboards = [...sortedDashboards]
		}
	}
}

export const actions = {
	getDashboards ({ commit }, { addCookieModule, submissionFragmentsEnabled }) {
		return new Promise((resolve, reject) => {
			configApi
				.get('/api/dashboard')
				.then(response => {
					const dashboards = response.data
					commit('SET_DASHBOARDS', { dashboards, addCookieModule })
					resolve(dashboards)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}
